var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLefte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 628,
    viewBox: "0 0 366 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 495.772,
    cy: 322.746,
    r: 321.5,
    transform: "rotate(-164.464 495.772 322.746)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.901,
    cy: 321.452,
    r: 331.141,
    transform: "rotate(-164.464 481.901 321.452)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.292,
    cy: 317.237,
    r: 337.188,
    transform: "rotate(-164.464 458.292 317.237)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.46,
    cy: 309.229,
    r: 344.034,
    transform: "rotate(-164.464 425.46 309.229)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.286,
    cy: 329.588,
    r: 307.822,
    transform: "rotate(-164.464 512.286 329.588)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 525.511,
    cy: 332.457,
    r: 291.685,
    transform: "rotate(-164.464 525.511 332.457)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 532.426,
    cy: 336.086,
    r: 271.683,
    transform: "rotate(-164.464 532.426 336.086)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 548.406,
    cy: 330.293,
    r: 254.46,
    transform: "rotate(-164.464 548.406 330.293)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 563.602,
    cy: 331.96,
    r: 231.178,
    transform: "rotate(-164.464 563.602 331.96)",
    stroke: "#3DAFE2",
    strokeOpacity: 0.24,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLefte);
export default __webpack_public_path__ + "static/media/lefte.808544cf4678a3b1f544ae09d13193dd.svg";
export { ForwardRef as ReactComponent };